module.exports = __webpack_public_path__ + "assets/drconecta-ico-pickdate.c86bb0a0.svg";